export enum SocialMediaInfo {
  COPY_LINK = "Copy Link",
  SUCCESS = "success",
  COPIED_SUCCESSFULLY = "Link copied successfully",
  FACEBOOK = "Facebook",
  WHATSAPP = "WhatsApp",
  MAIL = "Mail",
  TWITTER = "X",
  NAMASTE = "Namaste!",
  ORDER_TEXT_PREFIX = "You can now order online from",
  ORDER_TEXT_SUFFIX = "using this link:",
  CONTACT_US_PREFIX = "Contact us on",
  CONTACT_US_SUFFIX = "if you need any help with ordering online",
  THANK_YOU = "Thank You."
}
